import moment from "moment";
import InfoIcon from "../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import DownloadIcon from "../../../components/Common/SvgIcons/TableIcons/DownloadIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { distribute } from "./distribute";
import { FormattedMessage } from "react-intl";

export const dateFormatmmddyyyy = (date) => {
  const today = date;
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  return mm + "/" + dd + "/" + yyyy;
};

export const formatDate = (dateString) => {
  return moment(new Date(dateString)).format("DD/MM/YYYY hh:mm:ss A");
};

export const distributionHistoryMode = (mode) => {
  switch (mode) {
    case "UserGroups":
      return "Group";
    case "Tags":
      return "Distribution List";
    case "SelectedUsers":
      return "Users";
    case "NextPush":
      return "Self Paced";
    case "SpreadProgram":
      return "Stretched";
    case "NewJoinee":
      return "Mandate Learning";
    case "Mandate Learning":
      return "Mandate Learning";
    case "Refresher":
      return "Refresher";
    case "SelfAssignment":
      return "Self Assignment";
    case "DistributeCSV":
      return "CSV File";
    default:
      return "";
  }
};

export let distributionHistory = {
  name: "Distribution History",
  label: <FormattedMessage id="DISTRIBUTION_HISTORY" />,
  path: (tenantName) => `/${tenantName}/distribute/distributionHistory`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: distribute.name,
      path: distribute.path(tenantName),
      onClick: () => navigate(`${distribute.path(tenantName)}`),
    },
    {
      key: 2,
      label: distributionHistory.label,
      path: `${distributionHistory.path(tenantName)}`,
      onClick: () => navigate(`${distributionHistory.path(tenantName)}`),
    },
  ],
  columns: (handleViewModal, setviewModal) => [
    {
      ID: 1,
      name: <FormattedMessage id="DIST_DISTRIBUTION_ON" />,
      fieldName: "DistributedOn",
      value: (row) => formatDate(row.DistributedOn),
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 2,
      name: <FormattedMessage id="DIST_HISTORY_STATUS" />,
      fieldName: "Status",
      value: (row) => row.Status,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="DIST_HIST_DISTRIBUTED_BY" />,
      fieldName: "DistributedBy",
      value: (row) => (
        <div
          title={
            row.DistributionMethod === "SelfAssignment"
              ? "System"
              : row?.DistributedBy
          }
        >
          {row.DistributionMethod === "SelfAssignment"
            ? "System"
            : row?.DistributedBy?.length > 25
            ? row?.DistributedBy?.slice(0, 23) + "..."
            : row?.DistributedBy}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="DIST_HIST_DISTRIBUTION_MODE" />,
      fieldName: "DistributionMethod",
      value: (row) => distributionHistoryMode(row.DistributionMethod),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="DIST_HIST_LAST_MODIFIED" />,
      fieldName: "ModifiedOn",
      value: (row) => formatDate(row.ModifiedOn),
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 6,
      name: <FormattedMessage id="DIST_HIST_SUCCESS_COUNT" />,
      fieldName: "SuccessCount",
      value: (row) => row.SuccessCount,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 7,
      name: <FormattedMessage id="DIST_HIST_FAILURE_COUNT" />,
      fieldName: "FailureCount",
      value: (row) => row.FailureCount,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 8,
      name: "Info",
      fieldName: "VotesCount",
      value: (row) => (
        <Tooltip
          direction="bottom"
          content={<FormattedMessage id="HISTORY_INFO" />}
        >
          <div
            onClick={() => {
              handleViewModal(row);
              setviewModal(true);
            }}
          >
            <InfoIcon />
          </div>
        </Tooltip>
      ),
      sort: false,
    },

    {
      ID: 9,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <Tooltip
          direction="bottom"
          content={<FormattedMessage id="EXPORT_CSV" />}
        >
          <a href={row.LogPath} download>
            <DownloadIcon />
          </a>
        </Tooltip>
      ),
      sort: false,
    },
  ],
  distributionHistoryCoursesInfocolumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="P_Name" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="DIST_HIST_TYPE" />,
      fieldName: "Type",
      value: (row) => row.Type,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
  distributionHistoryDistributedInfocolumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="DIST_HIST_USER_GRP" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
  distributionHistoryDistributedInfoForSelfAssignmentcolumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_USERNAME_TXT" />,
      fieldName: "FirstName",
      value: (row) =>
        `${row?.FirstName ? row?.FirstName + " " : ""} ${
          row?.LastName ? row?.LastName : ""
        }`,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
  distributionHistoryDistributedInfoForDistributionListcolumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="DIST_HISTORY_COUNTRY" />,
      fieldName: "Country",
      value: (row) => row?.Country,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="DIST_HISTORY_STATE" />,
      fieldName: "State",
      value: (row) => row?.State,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="DIST_HISTORY_CITY" />,
      fieldName: "City",
      value: (row) => row?.City,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="DISTRIBUTE_STORE" />,
      fieldName: "Store",
      value: (row) => row?.Store,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="USERMANAGE_CATEGORY" />,
      fieldName: "Category",
      value: (row) => row?.Category,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
};
